import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltCommentDialogThreadCardReactionTool = function (props) {
    var children = props.children, excludeReactionIds = props.excludeReactionIds, remainingProps = __rest(props, ["children", "excludeReactionIds"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-reaction-tool-wireframe", __assign({}, transformedProps, { "exclude-reaction-ids": excludeReactionIds ? JSON.stringify(excludeReactionIds) : undefined }), children));
};
export default VeltCommentDialogThreadCardReactionTool;
